import { render, staticRenderFns } from "./benefits-card.vue?vue&type=template&id=3f3a7f57"
import script from "./benefits-card.vue?vue&type=script&lang=js"
export * from "./benefits-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports